export class CountryModel {
  name: string;
  code: string;
  id: string;
  version: string;
}
